
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import Swiper from '@devsisters/ui-common/lib/Swiper';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"swiper"}}>{`Swiper`}</MDXTag>
<MDXTag name="p" components={components}>{`캐러셀 ui를 만들기 위한 라이브러리인 `}<MDXTag name="a" components={components} parentName="p" props={{"href":"https://github.com/kidjp85/react-id-swiper"}}>{`react-id-swiper`}</MDXTag>{`를
타입 안전하게 사용할 수 있도록 얇게 감싸놓은 컴포넌트입니다.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import Swiper from '@devsisters/ui-common/lib/Swiper';
`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"기본"}}>{`기본`}</MDXTag>
<MDXTag name="p" components={components}>{`(화면을 드래그해서 슬라이드를 좌우로 넘겨보세요)`}</MDXTag>
<Playground __position={0} __code={'<div style={{ overflow: \'hidden\' }}>\n  <Swiper\n    containerClass={\'swiper\'}\n    slideActiveClass={\'active-slide\'}\n    initialSlide={1}\n  >\n    {[\'첫번째\', \'두번째\', \'세번째\'].map((v, i) => (\n      <h1 key={i}>{v}</h1>\n    ))}\n  </Swiper>\n</div>'} __scope={{props: this ? this.props : props,Swiper}}>
  <div style={{ overflow: 'hidden' }}>
    <Swiper
      containerClass={'swiper'}
      slideActiveClass={'active-slide'}
      initialSlide={1}>
      { ['첫번째', '두번째', '세번째'].map((v, i) => <h1 key={i}>{ v }</h1>) }
    </Swiper>
  </div>
</Playground>
<MDXTag name="h2" components={components} props={{"id":"페이드-인아웃"}}>{`페이드 인/아웃`}</MDXTag>
<MDXTag name="p" components={components}>{`(화면을 드래그해서 슬라이드를 좌우로 넘겨보세요)`}</MDXTag>
<Playground __position={1} __code={'<Swiper effect=\"fade\" fadeEffect={{ crossFade: true }} autoplay>\n  {[\'첫번째\', \'두번째\', \'세번째\'].map((v, i) => (\n    <h1 key={i}>{v}</h1>\n  ))}\n</Swiper>'} __scope={{props: this ? this.props : props,Swiper}}>
  <Swiper
    effect='fade'
    fadeEffect={{ crossFade: true }}
    autoplay>
    { ['첫번째', '두번째', '세번째'].map((v, i) => <h1 key={i}>{ v }</h1>) }
  </Swiper>
</Playground>
<MDXTag name="h2" components={components} props={{"id":"패럴랙스"}}>{`패럴랙스`}</MDXTag>
<MDXTag name="p" components={components}>{`(화면을 드래그해서 슬라이드를 좌우로 넘겨보세요)`}</MDXTag>
<Playground __position={2} __code={'<Swiper parallax>\n  {[1, 2, 3].map(v => (\n    <div key={v}>\n      <h1 data-swiper-parallax=\"0%\" data-swiper-parallax-opacity=\"0\">\n        내용 {v}\n      </h1>\n      <h2 data-swiper-parallax=\"-50%\" data-swiper-parallax-opacity=\"0\">\n        다른 내용 {v}\n      </h2>\n      <h3 data-swiper-parallax=\"-100%\" data-swiper-parallax-opacity=\"0\">\n        새로운 내용 {v}\n      </h3>\n    </div>\n  ))}\n</Swiper>'} __scope={{props: this ? this.props : props,Swiper}}>
  <Swiper parallax>
    { [1, 2, 3].map(v => <div key={v}>
      <h1
        data-swiper-parallax='0%'
        data-swiper-parallax-opacity='0'>
        내용 { v }
      </h1>
      <h2
        data-swiper-parallax='-50%'
        data-swiper-parallax-opacity='0'>
        다른 내용 { v }
      </h2>
      <h3
        data-swiper-parallax='-100%'
        data-swiper-parallax-opacity='0'>
        새로운 내용 { v }
      </h3>
    </div>) }
  </Swiper>
</Playground>
<MDXTag name="h2" components={components} props={{"id":"커버플로우"}}>{`커버플로우`}</MDXTag>
<MDXTag name="p" components={components}>{`(화면을 드래그해서 슬라이드를 좌우로 넘겨보세요)`}</MDXTag>
<Playground __position={3} __code={'<Swiper\n  initialSlide={1}\n  centeredSlides={true}\n  slidesPerView=\"auto\"\n  effect=\"coverflow\"\n  coverflowEffect={{\n    rotate: 0,\n    depth: 200,\n  }}\n>\n  {[\n    \'https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/f68c2fc0-dcd4-11e8-ad6b-dbc6c1f40db4.png\',\n    \'https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/fc7b8110-dcd4-11e8-ad6b-dbc6c1f40db4.png\',\n    \'https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/01489980-dcd5-11e8-ad6b-dbc6c1f40db4.png\',\n  ].map((v, i) => (\n    <img key={i} src={v} style={{ width: \'197px\', height: \'312px\' }} />\n  ))}\n</Swiper>'} __scope={{props: this ? this.props : props,Swiper}}>
  <Swiper
    initialSlide={1}
    centeredSlides={true}
    slidesPerView='auto'
    effect='coverflow'
    coverflowEffect={{
      rotate: 0,
      depth: 200,
    }}>
    { [
      'https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/f68c2fc0-dcd4-11e8-ad6b-dbc6c1f40db4.png',
      'https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/fc7b8110-dcd4-11e8-ad6b-dbc6c1f40db4.png',
      'https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/01489980-dcd5-11e8-ad6b-dbc6c1f40db4.png',
    ].map((v, i) => <img
      key={i}
      src={v}
      style={{ width: '197px', height: '312px' }}
    />) }
  </Swiper>
</Playground>
           </MDXTag>
  }
}
  